import {
  CARD_CVC,
  CARD_DATE,
  CARD_NUMBER
} from "payments/components/CardElements";

import { SOY } from "reservations/brand/helpers/v1/palette";

export const COMMERCE_HUB_FIELD_TYPE_TO_FIELD_STATE = {
  cardNumber: "cardNumber",
  securityCode: "cvv",
  expiration: "expirationDate"
};

export const COMMERCE_HUB_FIELD_TYPE_TO_HUMAN_READABLE_NAME = {
  cardNumber: "Card number",
  securityCode: "Card CVV",
  expiration: "Card expiry"
};

export const COMMERCE_HUB_URL =
  "https://commercehub-secure-data-capture.fiservapps.com/0.11.0/saq-a.js";

export const COMMERCE_HUB_PAYMENT_FORM_CUSTOMIZATIONS = {
  "fields": {
    "cardNumber": {
      "parentElementId": CARD_NUMBER,
      "placeholder": "Card Number",
      "dynamicPlaceholderCharacter": "•",
      "enableFormatting": true,
      "masking": {
        "character": "•",
        "mode": "NO_MASKING",
        "shrunkLength": 4
      }
    },
    "securityCode": {
      "parentElementId": CARD_CVC,
      "placeholder": "CVC",
      "dynamicPlaceholderCharacter": "•",
      "masking": {
        "character": "•",
        "mode": "NO_MASKING"
      }
    },
    "expiration": {
      "parentElementId": CARD_DATE,
      "placeholder": "MM / YY"
    }
  },
  "css": {
    "input, select": {
      "font-size": "16px",
      "font-family": "Helvetica, Arial, sans-serif",
      "line-height": "20px",
      "color": SOY,
      "background-color": "transparent"
    },
    "input::placeholder": {
      "color": "transparent"
    }
  }
};
